<template>
  <div class="three_contain_cla">
    <i v-if="!leftOpen"
       v-bind:style="{ 'background-color': getTheme}"
       @click.stop="leftOpen=!leftOpen"
       class="el-icon-d-arrow-right icon_cla"></i>
    <div :style="leftStyle"
         class="col_cla"
         v-bind:class="{OpenCla: !leftOpen }">
      <i v-if="leftOpen"
         v-bind:style="{ 'background-color': getTheme}"
         @click.stop="leftOpen=!leftOpen"
         class="el-icon-d-arrow-left icon_cla"></i>
      <div v-if="leftOpen"
           class="el-card box-card is-always-shadow box-card">
        <div v-bind:style="{ 'background-color': getBreadTheme}"
             class="zkCard_head">
          <span>{{leftTitle}}</span>
        </div>
        <div class="zkCard_body">
          <slot name="clo1"></slot>
        </div>
      </div>
    </div>

    <div :style="rightStyle"
         class="col_cla">
      <div class="el-card box-card is-always-shadow box-card">
        <div v-bind:style="{ 'background-color': getBreadTheme}"
             class="zkCard_head">
          <span>{{rightTitle}}</span>
        </div>
        <div class="zkCard_body">
          <slot name="clo2"></slot>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      leftOpen: true
    }
  },
  name: 'zkTwoColumn',
  computed: {
    ...mapGetters({
      getTheme: 'getTheme',
      getBreadTheme: 'getBreadTheme'
    })
  },
  props: {
    leftStyle: {
      type: String,
      default: ''
    },
    rightStyle: {
      type: String,
      default: ''
    },
    leftTitle: {
      type: String,
      default: ''
    },
    rightTitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
@CardHeadHeight: 40px;
.three_contain_cla {
  margin-left: 0px;
  margin-right: 0px;
  height: 100%;
  .icon_cla {
    width: 40px;
    height: @CardHeadHeight;
    cursor: pointer;
    text-align: center;
    line-height: 48px;
    margin-right: 5px;
    float: left;
    border-radius: 5px;
    color: #fff;
  }
  .box-card {
    height: 100%;
    padding-top: @CardHeadHeight;
    box-sizing: border-box;
    position: relative;
    .zkCard_head {
      height: @CardHeadHeight;
      line-height: @CardHeadHeight;
      // border-bottom: 1px solid #ebeef5;
      box-sizing: border-box;
      position: absolute;
      padding: 0px 20px;
      top: 0px;
      width: 100%;
      color: #fff;
    }
    .zkCard_body {
      padding: 15px;
      height: 100%;
      box-sizing: border-box;
      overflow: auto;
    }
  }

  .col_cla {
    position: relative;
    height: 100%;
    padding-left: 5px;
    padding-right: 5px;
    box-sizing: border-box;

    .icon_cla {
      position: absolute;
      right: 10px;
      width: 40px;
      height: @CardHeadHeight - 1px;
      cursor: pointer;
      text-align: center;
      line-height: @CardHeadHeight;
      color: #fff;
      z-index: 1000;
      top: 1px;
    }
  }

  .col_cla:nth-of-type(1) {
    float: left;
    width: 25%;
    height: 100%;
  }
  .col_cla:nth-of-type(2) {
    overflow: hidden;
    height: 100%;
  }
}

@media only screen and (min-width: 901px) {
  .OpenCla {
    display: none;
    overflow: auto;
  }
}

@media only screen and (max-width: 900px) {
  .icon_cla {
    display: none;
  }
  .OpenCla {
    width: 100% !important;
    overflow: auto;
  }
  .col_cla {
    width: 100% !important;
    margin: 10px;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/twoColumn.vue